// extracted by mini-css-extract-plugin
export default {"container":"style_container__pn3rL","loading_container":"style_loading_container__yVfjg","text":"style_text__qlf0F"};